/**
 * File generated by js-routes 2.2.8
 * Based on Rails 7.0.8.5 routes of Capture::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/observation_events/add_observation_events(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_observation_events_admin_area_custom_scenario_observation_events_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[6,"add_observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/observation_events/add_observation_events(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_observation_events_organisation_area_custom_scenario_observation_events_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[6,"add_observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_custom_scenario_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/available_environments(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_custom_scenario_available_environments_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"available_environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/available_incidents(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_custom_scenario_available_incidents_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"available_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/available_injects(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_custom_scenario_available_injects_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"available_injects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/observation_events/:id(.:format)
 * @param {any} custom_scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_custom_scenario_observation_event_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/observation_events(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_custom_scenario_observation_events_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/publish(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_custom_scenario_publish_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/step2_environment(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_custom_scenario_step2_environment_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"step2_environment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/step3_incident(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_custom_scenario_step3_incident_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"step3_incident"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/step4_callout_message(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_custom_scenario_step4_callout_message_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"step4_callout_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/step_injects(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_custom_scenario_step_injects_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"step_injects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/update_active_step(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_custom_scenario_update_active_step_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"update_active_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dash(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dash"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/articulates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_articulate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"articulates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/articulates/:articulate_id/preview_data(.:format)
 * @param {any} articulate_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_articulate_preview_data_path = /*#__PURE__*/ __jsr.r({"articulate_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"articulates"],[2,[7,"/"],[2,[3,"articulate_id"],[2,[7,"/"],[2,[6,"preview_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/articulates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_articulates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"articulates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/contents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_content_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/contents/:content_id/approved_organisations(.:format)
 * @param {any} content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_content_approved_organisations_path = /*#__PURE__*/ __jsr.r({"content_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[3,"content_id"],[2,[7,"/"],[2,[6,"approved_organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/contents/:content_id/organisations/:id(.:format)
 * @param {any} content_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_content_organisation_path = /*#__PURE__*/ __jsr.r({"content_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[3,"content_id"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/contents/:content_id/organisations(.:format)
 * @param {any} content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_content_organisations_path = /*#__PURE__*/ __jsr.r({"content_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[3,"content_id"],[2,[7,"/"],[2,[6,"organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/contents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_contents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/add_content(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_add_content_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"add_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/approved_organisations(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_approved_organisations_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"approved_organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/assign_units(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_assign_units_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"assign_units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/contents(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_contents_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/duplicate(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_duplicate_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/enrolments/:enrolment_id/disable_enrolment(.:format)
 * @param {any} course_id
 * @param {any} enrolment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_enrolment_disable_enrolment_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"enrolment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"disable_enrolment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/enrolments(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_enrolments_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"enrolments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/load_units_for_assign(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_load_units_for_assign_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"load_units_for_assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/not_approved_organisations(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_not_approved_organisations_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"not_approved_organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/order_contents(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_order_contents_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"order_contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/organisations/:id(.:format)
 * @param {any} course_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_organisation_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/organisations(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_organisations_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/remove_content(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_remove_content_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"remove_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/unassign_unit(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_unassign_unit_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"unassign_unit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/units(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_units_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:course_id/update_status(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_course_update_status_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_courses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/enrolments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_enrolment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/enrolments/:enrolment_id/activity_data(.:format)
 * @param {any} enrolment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_enrolment_activity_data_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"activity_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/enrolments/:enrolment_id/disable_enrolment(.:format)
 * @param {any} enrolment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_enrolment_disable_enrolment_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"disable_enrolment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/enrolments/:enrolment_id/presentations/:id(.:format)
 * @param {any} enrolment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_enrolment_presentation_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/enrolments/:enrolment_id/quiz/:id(.:format)
 * @param {any} enrolment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_enrolment_quiz_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/enrolments/:enrolment_id/quiz/:quiz_id/questions/:id(.:format)
 * @param {any} enrolment_id
 * @param {any} quiz_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_enrolment_quiz_question_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"quiz_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/enrolments/:enrolment_id/scenarios/:id(.:format)
 * @param {any} enrolment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_enrolment_scenario_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/enrolments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_enrolments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/presentations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_presentation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/presentations/:presentation_id/preview_data(.:format)
 * @param {any} presentation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_presentation_preview_data_path = /*#__PURE__*/ __jsr.r({"presentation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"presentation_id"],[2,[7,"/"],[2,[6,"preview_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/presentations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_presentations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"presentations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/quiz/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_quiz_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/quiz/:quiz_id/duplicate(.:format)
 * @param {any} quiz_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_quiz_duplicate_path = /*#__PURE__*/ __jsr.r({"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/quiz(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_quiz_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/quiz/:quiz_id/preview_data(.:format)
 * @param {any} quiz_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_quiz_preview_data_path = /*#__PURE__*/ __jsr.r({"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"preview_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/quiz/:quiz_id/questions/:id(.:format)
 * @param {any} quiz_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_quiz_question_path = /*#__PURE__*/ __jsr.r({"quiz_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/quiz/:quiz_id/questions(.:format)
 * @param {any} quiz_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_online_courses_quiz_questions_path = /*#__PURE__*/ __jsr.r({"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/archive(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_archive_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/custom_reports/:id(.:format)
 * @param {any} organisation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_custom_report_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"custom_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/custom_reports(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_custom_reports_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"custom_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/link_unit(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_link_unit_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"link_unit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/reinstate(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_reinstate_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"reinstate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/simulations(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_simulations_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"simulations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/statistics(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_statistics_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/students(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_students_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/toggle_course_engine(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_toggle_course_engine_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"toggle_course_engine"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/toggle_custom_scenario(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_toggle_custom_scenario_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"toggle_custom_scenario"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/toggle_lms_content_course_access(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_toggle_lms_content_course_access_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"toggle_lms_content_course_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/units(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_units_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/users/:id(.:format)
 * @param {any} organisation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_user_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/users(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisation_users_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_organisations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/payloads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_payloads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payloads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/playlists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_playlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/playlists/:playlist_id/approved_organisations(.:format)
 * @param {any} playlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_playlist_approved_organisations_path = /*#__PURE__*/ __jsr.r({"playlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"playlist_id"],[2,[7,"/"],[2,[6,"approved_organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/playlists/:playlist_id/duplicate(.:format)
 * @param {any} playlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_playlist_duplicate_path = /*#__PURE__*/ __jsr.r({"playlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"playlist_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/playlists/:playlist_id/not_approved_organisations(.:format)
 * @param {any} playlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_playlist_not_approved_organisations_path = /*#__PURE__*/ __jsr.r({"playlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"playlist_id"],[2,[7,"/"],[2,[6,"not_approved_organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/playlists/:playlist_id/organisations/:id(.:format)
 * @param {any} playlist_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_playlist_organisation_path = /*#__PURE__*/ __jsr.r({"playlist_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"playlist_id"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/playlists/:playlist_id/organisations(.:format)
 * @param {any} playlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_playlist_organisations_path = /*#__PURE__*/ __jsr.r({"playlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"playlist_id"],[2,[7,"/"],[2,[6,"organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/playlists/:playlist_id/unassign_unit(.:format)
 * @param {any} playlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_playlist_unassign_unit_path = /*#__PURE__*/ __jsr.r({"playlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"playlist_id"],[2,[7,"/"],[2,[6,"unassign_unit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/playlists/:playlist_id/units_tab(.:format)
 * @param {any} playlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_playlist_units_tab_path = /*#__PURE__*/ __jsr.r({"playlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"playlist_id"],[2,[7,"/"],[2,[6,"units_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/playlists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_playlists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/approved_organisations(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_approved_organisations_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"approved_organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/event_refs(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_event_refs_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_refs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/event_versions/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_event_version_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_versions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/event_versions/:event_version_id/add_micro_event(.:format)
 * @param {any} scenario_id
 * @param {any} event_version_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_event_version_add_micro_event_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"event_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_versions"],[2,[7,"/"],[2,[3,"event_version_id"],[2,[7,"/"],[2,[6,"add_micro_event"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/event_versions/:event_version_id/add_performance_event(.:format)
 * @param {any} scenario_id
 * @param {any} event_version_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_event_version_add_performance_event_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"event_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_versions"],[2,[7,"/"],[2,[3,"event_version_id"],[2,[7,"/"],[2,[6,"add_performance_event"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/event_versions/:event_version_id/delete_micro_event(.:format)
 * @param {any} scenario_id
 * @param {any} event_version_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_event_version_delete_micro_event_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"event_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_versions"],[2,[7,"/"],[2,[3,"event_version_id"],[2,[7,"/"],[2,[6,"delete_micro_event"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/event_versions/:event_version_id/delete_performance_event(.:format)
 * @param {any} scenario_id
 * @param {any} event_version_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_event_version_delete_performance_event_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"event_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_versions"],[2,[7,"/"],[2,[3,"event_version_id"],[2,[7,"/"],[2,[6,"delete_performance_event"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/event_versions/:event_version_id/load_micro_events_for_add(.:format)
 * @param {any} scenario_id
 * @param {any} event_version_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_event_version_load_micro_events_for_add_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"event_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_versions"],[2,[7,"/"],[2,[3,"event_version_id"],[2,[7,"/"],[2,[6,"load_micro_events_for_add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/event_versions/:event_version_id/publish(.:format)
 * @param {any} scenario_id
 * @param {any} event_version_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_event_version_publish_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"event_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_versions"],[2,[7,"/"],[2,[3,"event_version_id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/event_versions/:event_version_id/reorder_micro_event(.:format)
 * @param {any} scenario_id
 * @param {any} event_version_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_event_version_reorder_micro_event_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"event_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_versions"],[2,[7,"/"],[2,[3,"event_version_id"],[2,[7,"/"],[2,[6,"reorder_micro_event"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/event_versions/:event_version_id/reorder_performance_event(.:format)
 * @param {any} scenario_id
 * @param {any} event_version_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_event_version_reorder_performance_event_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"event_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_versions"],[2,[7,"/"],[2,[3,"event_version_id"],[2,[7,"/"],[2,[6,"reorder_performance_event"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/event_versions/:event_version_id/toggle_micro_event_critical(.:format)
 * @param {any} scenario_id
 * @param {any} event_version_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_event_version_toggle_micro_event_critical_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"event_version_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_versions"],[2,[7,"/"],[2,[3,"event_version_id"],[2,[7,"/"],[2,[6,"toggle_micro_event_critical"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/event_versions(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_event_versions_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/events(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_events_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/injects(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_injects_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"injects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/learning_outcomes/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_learning_outcome_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"learning_outcomes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/learning_outcomes(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_learning_outcomes_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"learning_outcomes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/micro_events/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_micro_event_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"micro_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/micro_events/:micro_event_id/toggle_status(.:format)
 * @param {any} scenario_id
 * @param {any} micro_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_micro_event_toggle_status_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"micro_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"micro_events"],[2,[7,"/"],[2,[3,"micro_event_id"],[2,[7,"/"],[2,[6,"toggle_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/micro_events(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_micro_events_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"micro_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/observation_events(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_observation_events_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/organisations/:id(.:format)
 * @param {any} scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_organisation_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/organisations(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_organisations_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/performance_events(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_performance_events_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"performance_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/preview(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_preview_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/simulations(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_simulations_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"simulations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/statistics(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_statistics_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:scenario_id/toggle_status(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenario_toggle_status_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"toggle_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_scenarios_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/environments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_environment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/environments/:environment_id/approved_organisations(.:format)
 * @param {any} environment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_environment_approved_organisations_path = /*#__PURE__*/ __jsr.r({"environment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"environment_id"],[2,[7,"/"],[2,[6,"approved_organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/environments/:environment_id/incidents(.:format)
 * @param {any} environment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_environment_incidents_path = /*#__PURE__*/ __jsr.r({"environment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"environment_id"],[2,[7,"/"],[2,[6,"incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/environments/:environment_id/not_approved_organisations(.:format)
 * @param {any} environment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_environment_not_approved_organisations_path = /*#__PURE__*/ __jsr.r({"environment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"environment_id"],[2,[7,"/"],[2,[6,"not_approved_organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/environments/:environment_id/organisations/:id(.:format)
 * @param {any} environment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_environment_organisation_path = /*#__PURE__*/ __jsr.r({"environment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"environment_id"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/environments/:environment_id/organisations(.:format)
 * @param {any} environment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_environment_organisations_path = /*#__PURE__*/ __jsr.r({"environment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"environment_id"],[2,[7,"/"],[2,[6,"organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/environments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_environments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/event_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_event_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"event_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/event_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_event_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"event_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/event_libraries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_event_libraries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"event_libraries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_incident_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/approved_organisations(.:format)
 * @param {any} incident_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_incident_approved_organisations_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"approved_organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/injects(.:format)
 * @param {any} incident_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_incident_injects_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"injects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/not_approved_organisations(.:format)
 * @param {any} incident_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_incident_not_approved_organisations_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"not_approved_organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/observation_events/:id(.:format)
 * @param {any} incident_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_incident_observation_event_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/observation_events(.:format)
 * @param {any} incident_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_incident_observation_events_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/organisations/:id(.:format)
 * @param {any} incident_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_incident_organisation_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/organisations(.:format)
 * @param {any} incident_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_incident_organisations_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"organisations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/performance_events/:id(.:format)
 * @param {any} incident_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_incident_performance_event_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"performance_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/performance_events(.:format)
 * @param {any} incident_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_incident_performance_events_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"performance_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/toggle_status(.:format)
 * @param {any} incident_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_incident_toggle_status_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"toggle_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_incidents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/injects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_inject_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"injects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/injects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_injects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"injects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/micro_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_micro_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"micro_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/micro_events/:micro_event_id/toggle_status(.:format)
 * @param {any} micro_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_micro_event_toggle_status_path = /*#__PURE__*/ __jsr.r({"micro_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"micro_events"],[2,[7,"/"],[2,[3,"micro_event_id"],[2,[7,"/"],[2,[6,"toggle_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/micro_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_micro_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"micro_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/observation_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_observation_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/observation_events/:observation_event_id/toggle_status(.:format)
 * @param {any} observation_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_observation_event_toggle_status_path = /*#__PURE__*/ __jsr.r({"observation_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[3,"observation_event_id"],[2,[7,"/"],[2,[6,"toggle_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/observation_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_observation_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/performance_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_performance_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"performance_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/performance_events/:performance_event_id/toggle_status(.:format)
 * @param {any} performance_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_performance_event_toggle_status_path = /*#__PURE__*/ __jsr.r({"performance_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"performance_events"],[2,[7,"/"],[2,[3,"performance_event_id"],[2,[7,"/"],[2,[6,"toggle_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/performance_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_performance_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"performance_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/timeline_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_timeline_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"timeline_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/timeline_events/:timeline_event_id/toggle_status(.:format)
 * @param {any} timeline_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_timeline_event_toggle_status_path = /*#__PURE__*/ __jsr.r({"timeline_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"timeline_events"],[2,[7,"/"],[2,[3,"timeline_event_id"],[2,[7,"/"],[2,[6,"toggle_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/timeline_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_timeline_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"timeline_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/users/:user_id/grant_admin(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_user_grant_admin_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"grant_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/users/:user_id/grant_org_admin(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_user_grant_org_admin_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"grant_org_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/users/:user_id/revoke_admin(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_user_revoke_admin_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"revoke_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/users/:user_id/revoke_org_admin(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_user_revoke_org_admin_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"revoke_org_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/users/:user_id/send_password(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_user_send_password_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"send_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_settings_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/simulations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_simulation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/simulations/:simulation_id/assign_student(.:format)
 * @param {any} simulation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_simulation_assign_student_path = /*#__PURE__*/ __jsr.r({"simulation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"simulation_id"],[2,[7,"/"],[2,[6,"assign_student"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/simulations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_simulations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"simulations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_student_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/:student_id/archive(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_student_archive_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/:student_id/competencies(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_student_competencies_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"competencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/:student_id/enrolments(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_student_enrolments_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"enrolments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/:student_id/reports(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_student_reports_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/:student_id/simulations(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_student_simulations_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"simulations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/:student_id/statistics(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_student_statistics_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/:student_id/unarchive(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_student_unarchive_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/units/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_unit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/units/:unit_id/assign_org(.:format)
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_unit_assign_org_path = /*#__PURE__*/ __jsr.r({"unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"assign_org"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/units/:unit_id/assign_simulations(.:format)
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_unit_assign_simulations_path = /*#__PURE__*/ __jsr.r({"unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"assign_simulations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/units/:unit_id/courses(.:format)
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_unit_courses_path = /*#__PURE__*/ __jsr.r({"unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/units/:unit_id/notes/:id(.:format)
 * @param {any} unit_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_unit_note_path = /*#__PURE__*/ __jsr.r({"unit_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/units/:unit_id/notes(.:format)
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_unit_notes_path = /*#__PURE__*/ __jsr.r({"unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/units/:unit_id/playlists(.:format)
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_unit_playlists_path = /*#__PURE__*/ __jsr.r({"unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"playlists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/units/:unit_id/remove_from_org(.:format)
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_unit_remove_from_org_path = /*#__PURE__*/ __jsr.r({"unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"remove_from_org"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/units/:unit_id/simulations(.:format)
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_unit_simulations_path = /*#__PURE__*/ __jsr.r({"unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"simulations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_area_units_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/courses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_courses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/playlists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_playlists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"playlists"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/scenarios(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_scenarios_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"scenarios"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/simulations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_simulations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"simulations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/simulations/assignable_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignable_students_admin_area_simulations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[6,"assignable_students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/simulations/assignable_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assignable_students_organisation_area_simulations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[6,"assignable_students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /certificates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const certificate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"certificates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/students/check_email(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_email_admin_area_organisation_students_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"check_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/check_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_email_admin_area_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"check_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/check_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_email_organisation_area_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"check_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /student/details/check_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_email_student_area_details_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[2,[6,"check_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/check_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_email_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"check_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/micro_events/create_import_micro_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_import_micro_events_admin_area_settings_micro_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"micro_events"],[2,[7,"/"],[2,[6,"create_import_micro_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/observation_events/create_import_observation_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_import_observation_events_admin_area_settings_observation_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[6,"create_import_observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/performance_events/create_import_performance_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_import_performance_events_admin_area_settings_performance_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"performance_events"],[2,[7,"/"],[2,[6,"create_import_performance_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/students/create_import_students(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_import_students_admin_area_organisation_students_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"create_import_students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/create_import_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_import_students_admin_area_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"create_import_students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/create_import_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_import_students_organisation_area_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"create_import_students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/timeline_events/create_import_timeline_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_import_timeline_events_admin_area_settings_timeline_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"timeline_events"],[2,[7,"/"],[2,[6,"create_import_timeline_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/statistics/custom_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_reports_organisation_area_statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"custom_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/simulations/download_csv
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_csv_admin_area_simulations_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[6,"download_csv"]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/dropdown_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dropdown_search_admin_area_organisations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[6,"dropdown_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/articulates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_area_online_courses_articulate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"articulates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_area_online_courses_course_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/presentations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_area_online_courses_presentation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/quiz/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_area_online_courses_quiz_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_area_organisation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/users/:id/edit(.:format)
 * @param {any} organisation_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_area_organisation_user_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/playlists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_area_playlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_area_scenario_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/environments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_area_settings_environment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_area_settings_incident_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/injects/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_area_settings_inject_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"injects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/units/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_area_unit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organisation_area_online_courses_course_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/quiz/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organisation_area_online_courses_quiz_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/playlists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organisation_area_playlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organisation_area_scenario_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/profile/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organisation_area_settings_profile_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organisation_area_settings_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_organisation_area_student_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /password_resets/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_password_reset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"password_resets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student/details/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_student_area_details_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enrolments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enrolments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"enrolments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dev
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fflag_engine_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"dev"]]);

/**
 * Generates rails route to
 * /dev/toggles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fflag_engine_FFtoggle_toggles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"dev"]],[7,"/"]],[2,[6,"toggles"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dev/state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fflag_engine_FFtoggle_update_toggle_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"dev"]],[7,"/"]],[2,[6,"state"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/users/grant_org_admin(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_org_admin_admin_area_organisation_users_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"grant_org_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/users/grant_org_admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_org_admin_organisation_area_settings_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"grant_org_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /hello_world(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hello_world_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hello_world"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/observation_events/load_observation_events_for_add(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_observation_events_for_add_admin_area_custom_scenario_observation_events_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[6,"load_observation_events_for_add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/observation_events/load_observation_events_for_add(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_observation_events_for_add_organisation_area_custom_scenario_observation_events_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[6,"load_observation_events_for_add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mfa(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mfa_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mfa"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mfa_resend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mfa_resend_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mfa_resend"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mfa_verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mfa_verify_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mfa_verify"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/simulations/:id/micro_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const micro_events_admin_area_simulation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"micro_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/simulations/:id/micro_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const micro_events_organisation_area_simulation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"micro_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public_area/simulations/:id/micro_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const micro_events_public_area_simulation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public_area"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"micro_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student/simulations/:id/micro_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const micro_events_student_area_simulation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"micro_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/articulates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_online_courses_articulate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"articulates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/courses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_online_courses_course_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/presentations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_online_courses_presentation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/quiz/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_online_courses_quiz_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/quiz/:quiz_id/questions/new(.:format)
 * @param {any} quiz_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_online_courses_quiz_question_path = /*#__PURE__*/ __jsr.r({"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_organisation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/students/new(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_organisation_student_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/users/new(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_organisation_user_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/playlists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_playlist_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scenarios/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_scenario_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/environments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_settings_environment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"environments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_settings_incident_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/injects/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_settings_inject_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"injects"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_student_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/units/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_area_unit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /enrolments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_enrolment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/micro_events/new_import_micro_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_import_micro_events_admin_area_settings_micro_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"micro_events"],[2,[7,"/"],[2,[6,"new_import_micro_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/observation_events/new_import_observation_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_import_observation_events_admin_area_settings_observation_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[6,"new_import_observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/performance_events/new_import_performance_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_import_performance_events_admin_area_settings_performance_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"performance_events"],[2,[7,"/"],[2,[6,"new_import_performance_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organisations/:organisation_id/students/new_import_students(.:format)
 * @param {any} organisation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_import_students_admin_area_organisation_students_path = /*#__PURE__*/ __jsr.r({"organisation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organisations"],[2,[7,"/"],[2,[3,"organisation_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"new_import_students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/new_import_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_import_students_admin_area_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"new_import_students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/new_import_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_import_students_organisation_area_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"new_import_students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/timeline_events/new_import_timeline_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_import_timeline_events_admin_area_settings_timeline_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"timeline_events"],[2,[7,"/"],[2,[6,"new_import_timeline_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organisation_area_online_courses_course_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/quiz/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organisation_area_online_courses_quiz_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/quiz/:quiz_id/questions/new(.:format)
 * @param {any} quiz_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organisation_area_online_courses_quiz_question_path = /*#__PURE__*/ __jsr.r({"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/playlists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organisation_area_playlist_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organisation_area_scenario_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organisation_area_settings_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_organisation_area_student_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /password_resets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_password_reset_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password_resets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_student_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/observation_events/not_added_events(.:format)
 * @param {any} incident_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const not_added_events_admin_area_settings_incident_observation_events_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[6,"not_added_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/performance_events/not_added_events(.:format)
 * @param {any} incident_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const not_added_events_admin_area_settings_incident_performance_events_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"performance_events"],[2,[7,"/"],[2,[6,"not_added_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/simulations/:id/observation_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const observation_events_admin_area_simulation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/simulations/:id/observation_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const observation_events_organisation_area_simulation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public_area/simulations/:id/observation_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const observation_events_public_area_simulation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public_area"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student/simulations/:id/observation_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const observation_events_student_area_simulation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_scenario_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/available_environments(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_scenario_available_environments_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"available_environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/available_incidents(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_scenario_available_incidents_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"available_incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/available_injects(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_scenario_available_injects_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"available_injects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/observation_events/:id(.:format)
 * @param {any} custom_scenario_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_scenario_observation_event_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/observation_events(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_scenario_observation_events_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/publish(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_scenario_publish_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/step2_environment(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_scenario_step2_environment_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"step2_environment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/step3_incident(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_scenario_step3_incident_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"step3_incident"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/step4_callout_message(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_scenario_step4_callout_message_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"step4_callout_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/step_injects(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_scenario_step_injects_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"step_injects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/update_active_step(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_custom_scenario_update_active_step_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"update_active_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/dash(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"dash"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/articulates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_articulate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"articulates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/articulates/:articulate_id/preview_data(.:format)
 * @param {any} articulate_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_articulate_preview_data_path = /*#__PURE__*/ __jsr.r({"articulate_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"articulates"],[2,[7,"/"],[2,[3,"articulate_id"],[2,[7,"/"],[2,[6,"preview_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/catalogues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_catalogues_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"catalogues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/contents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_contents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/add_content(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_add_content_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"add_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/assign_units(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_assign_units_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"assign_units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/contents(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_contents_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/duplicate(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_duplicate_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/enrolments(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_enrolments_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"enrolments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/invitations(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_invitations_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/load_units_for_assign(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_load_units_for_assign_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"load_units_for_assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/order_contents(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_order_contents_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"order_contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/remove_content(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_remove_content_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"remove_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/students/:student_id/add_invitation(.:format)
 * @param {any} course_id
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_student_add_invitation_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"add_invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/students(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_students_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/toggle_in_student_catalogue(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_toggle_in_student_catalogue_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"toggle_in_student_catalogue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/unassign_unit(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_unassign_unit_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"unassign_unit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/units(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_units_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses/:course_id/update_status(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_course_update_status_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/courses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_courses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/enrolments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_enrolment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/enrolments/:enrolment_id/activity_data(.:format)
 * @param {any} enrolment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_enrolment_activity_data_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"activity_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/enrolments/:enrolment_id/disable_enrolment(.:format)
 * @param {any} enrolment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_enrolment_disable_enrolment_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"disable_enrolment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/enrolments/:enrolment_id/presentations/:id(.:format)
 * @param {any} enrolment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_enrolment_presentation_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/enrolments/:enrolment_id/quiz/:id(.:format)
 * @param {any} enrolment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_enrolment_quiz_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/enrolments/:enrolment_id/quiz/:quiz_id/questions/:id(.:format)
 * @param {any} enrolment_id
 * @param {any} quiz_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_enrolment_quiz_question_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"quiz_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/enrolments/:enrolment_id/scenarios/:id(.:format)
 * @param {any} enrolment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_enrolment_scenario_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/enrolments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_enrolments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"enrolments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/presentations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_presentation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/presentations/:presentation_id/preview_data(.:format)
 * @param {any} presentation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_presentation_preview_data_path = /*#__PURE__*/ __jsr.r({"presentation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"presentation_id"],[2,[7,"/"],[2,[6,"preview_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/quiz/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_quiz_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/quiz/:quiz_id/duplicate(.:format)
 * @param {any} quiz_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_quiz_duplicate_path = /*#__PURE__*/ __jsr.r({"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/quiz(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_quiz_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/quiz/:quiz_id/preview_data(.:format)
 * @param {any} quiz_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_quiz_preview_data_path = /*#__PURE__*/ __jsr.r({"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"preview_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/quiz/:quiz_id/questions/:id(.:format)
 * @param {any} quiz_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_quiz_question_path = /*#__PURE__*/ __jsr.r({"quiz_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/quiz/:quiz_id/questions(.:format)
 * @param {any} quiz_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_online_courses_quiz_questions_path = /*#__PURE__*/ __jsr.r({"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/playlists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_playlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/playlists/:playlist_id/duplicate(.:format)
 * @param {any} playlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_playlist_duplicate_path = /*#__PURE__*/ __jsr.r({"playlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"playlist_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/playlists/:playlist_id/unassign_unit(.:format)
 * @param {any} playlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_playlist_unassign_unit_path = /*#__PURE__*/ __jsr.r({"playlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"playlist_id"],[2,[7,"/"],[2,[6,"unassign_unit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/playlists/:playlist_id/units_tab(.:format)
 * @param {any} playlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_playlist_units_tab_path = /*#__PURE__*/ __jsr.r({"playlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[3,"playlist_id"],[2,[7,"/"],[2,[6,"units_tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/playlists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_playlists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"playlists"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_scenario_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/:scenario_id/event_refs(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_scenario_event_refs_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"event_refs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/:scenario_id/events(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_scenario_events_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/:scenario_id/injects(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_scenario_injects_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"injects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/:scenario_id/micro_event_feedbacks(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_scenario_micro_event_feedbacks_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"micro_event_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/:scenario_id/observation_events(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_scenario_observation_events_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"observation_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/:scenario_id/performance_events(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_scenario_performance_events_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"performance_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/:scenario_id/preview(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_scenario_preview_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/:scenario_id/simulations(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_scenario_simulations_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"simulations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/:scenario_id/statistics(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_scenario_statistics_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios/:scenario_id/toggle_status(.:format)
 * @param {any} scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_scenario_toggle_status_path = /*#__PURE__*/ __jsr.r({"scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"scenario_id"],[2,[7,"/"],[2,[6,"toggle_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/scenarios(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_scenarios_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"scenarios"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/departments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_settings_department_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/departments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_settings_departments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"departments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/incidents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_settings_incident_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_settings_profile_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_settings_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/users/:user_id/grant_org_admin(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_settings_user_grant_org_admin_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"grant_org_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/users/:user_id/revoke_org_admin(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_settings_user_revoke_org_admin_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"revoke_org_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/users/:user_id/send_password(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_settings_user_send_password_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"send_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/settings/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_settings_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/simulations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_simulation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/simulations/:simulation_id/assign_student(.:format)
 * @param {any} simulation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_simulation_assign_student_path = /*#__PURE__*/ __jsr.r({"simulation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"simulation_id"],[2,[7,"/"],[2,[6,"assign_student"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/simulations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_simulations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"simulations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/students/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_student_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/:student_id/archive(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_student_archive_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/:student_id/check_student_for_merge(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_student_check_student_for_merge_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"check_student_for_merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/:student_id/competencies(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_student_competencies_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"competencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/:student_id/enrolments(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_student_enrolments_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"enrolments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/:student_id/merge(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_student_merge_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/:student_id/reports(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_student_reports_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/:student_id/reset_password(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_student_reset_password_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/:student_id/simulations(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_student_simulations_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"simulations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/:student_id/statistics(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_student_statistics_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students/:student_id/unarchive(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_student_unarchive_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/style(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_style_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"style"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org/units/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_unit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/units/:unit_id/courses(.:format)
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_unit_courses_path = /*#__PURE__*/ __jsr.r({"unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/units/:unit_id/notes(.:format)
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_unit_notes_path = /*#__PURE__*/ __jsr.r({"unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/units/:unit_id/playlists(.:format)
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_unit_playlists_path = /*#__PURE__*/ __jsr.r({"unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"playlists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/units/:unit_id/simulations(.:format)
 * @param {any} unit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_unit_simulations_path = /*#__PURE__*/ __jsr.r({"unit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_id"],[2,[7,"/"],[2,[6,"simulations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organisation_area_units_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /password_resets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const password_reset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"password_resets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /password_resets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const password_resets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password_resets"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/simulations/poll_csv
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poll_csv_admin_area_simulations_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[6,"poll_csv"]]]]]]);

/**
 * Generates rails route to
 * /profile/user_detail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_area_user_detail_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"user_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /public_area/simulations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_area_simulation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public_area"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/:custom_scenario_id/observation_events/reorder(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_admin_area_custom_scenario_observation_events_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/observation_events/reorder(.:format)
 * @param {any} incident_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_admin_area_settings_incident_observation_events_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/settings/incidents/:incident_id/performance_events/reorder(.:format)
 * @param {any} incident_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_admin_area_settings_incident_performance_events_path = /*#__PURE__*/ __jsr.r({"incident_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"incident_id"],[2,[7,"/"],[2,[6,"performance_events"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/:custom_scenario_id/observation_events/reorder(.:format)
 * @param {any} custom_scenario_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_organisation_area_custom_scenario_observation_events_path = /*#__PURE__*/ __jsr.r({"custom_scenario_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[3,"custom_scenario_id"],[2,[7,"/"],[2,[6,"observation_events"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/online_courses/quiz/:quiz_id/questions/reorder_questions(.:format)
 * @param {any} quiz_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_questions_admin_area_online_courses_quiz_questions_path = /*#__PURE__*/ __jsr.r({"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[6,"reorder_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /org/online_courses/quiz/:quiz_id/questions/reorder_questions(.:format)
 * @param {any} quiz_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_questions_organisation_area_online_courses_quiz_questions_path = /*#__PURE__*/ __jsr.r({"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"online_courses"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[6,"reorder_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /admin/playlists/scenarios(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scenarios_admin_area_playlists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[6,"scenarios"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/playlists/scenarios(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scenarios_organisation_area_playlists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[6,"scenarios"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/user_detail/send_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_password_profile_area_user_detail_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"user_detail"],[2,[7,"/"],[2,[6,"send_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_up_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /org/students/signup_qrcode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signup_qrcode_organisation_area_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"signup_qrcode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_scenarios/step1_detail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const step1_detail_admin_area_custom_scenarios_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[6,"step1_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/custom_scenarios/step1_detail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const step1_detail_organisation_area_custom_scenarios_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"custom_scenarios"],[2,[7,"/"],[2,[6,"step1_detail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /student/catalogues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_catalogues_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"catalogues"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /student/competencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_competencies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"competencies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /student/courses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_course_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /student/courses/:course_id/enrol(.:format)
 * @param {any} course_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_course_enrol_path = /*#__PURE__*/ __jsr.r({"course_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_id"],[2,[7,"/"],[2,[6,"enrol"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student/dash(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"dash"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /student/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_details_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /student/enrolments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_enrolment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /student/enrolments/:enrolment_id/activity_data(.:format)
 * @param {any} enrolment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_enrolment_activity_data_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"activity_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student/enrolments/:enrolment_id/presentations/:id(.:format)
 * @param {any} enrolment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_enrolment_presentation_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student/enrolments/:enrolment_id/presentations/:presentation_id/update_status(.:format)
 * @param {any} enrolment_id
 * @param {any} presentation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_enrolment_presentation_update_status_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"presentation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"presentations"],[2,[7,"/"],[2,[3,"presentation_id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student/enrolments/:enrolment_id/quiz/:id(.:format)
 * @param {any} enrolment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_enrolment_quiz_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student/enrolments/:enrolment_id/quiz/:quiz_id/questions/:id(.:format)
 * @param {any} enrolment_id
 * @param {any} quiz_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_enrolment_quiz_question_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"quiz_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student/enrolments/:enrolment_id/quiz/:quiz_id/questions/:question_id/proceed(.:format)
 * @param {any} enrolment_id
 * @param {any} quiz_id
 * @param {any} question_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_enrolment_quiz_question_proceed_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"quiz_id":{"r":true},"question_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"question_id"],[2,[7,"/"],[2,[6,"proceed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student/enrolments/:enrolment_id/quiz/:quiz_id/reattempt(.:format)
 * @param {any} enrolment_id
 * @param {any} quiz_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_enrolment_quiz_reattempt_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"quiz"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"reattempt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student/enrolments/:enrolment_id/scenarios/:id(.:format)
 * @param {any} enrolment_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_enrolment_scenario_path = /*#__PURE__*/ __jsr.r({"enrolment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"enrolments"],[2,[7,"/"],[2,[3,"enrolment_id"],[2,[7,"/"],[2,[6,"scenarios"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student/enrolments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_enrolments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"enrolments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /student/simulations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_simulation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"simulations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /student/simulations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_area_simulations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"simulations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/playlists/units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const units_admin_area_playlists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org/playlists/units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const units_organisation_area_playlists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[6,"playlists"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/user_detail/update_locale(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_locale_profile_area_user_detail_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"user_detail"],[2,[7,"/"],[2,[6,"update_locale"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

